import { type RoutePath, RoutePaths, allRoutes } from '@/routes'
import { type FC, type ReactNode, lazy } from 'react'
import { Route, Routes as RouterRoutes } from 'react-router-dom'

const HomePage = lazy(() => import('../pages/home'))
const PortfolioPage = lazy(() => import('../pages/portfolio'))
const GetUTYPage = lazy(() => import('../pages/get-uty'))
const UseUTYPage = lazy(() => import('../pages/use-uty'))
const DocumentationPage = lazy(() => import('../pages/documentation'))
const TermsOfUsePage = lazy(() => import('../pages/terms-of-use'))
const PrivacyPolicyPage = lazy(() => import('../pages/privacy-policy'))
const NotFound = lazy(() => import('../pages/not_found'))
const MintUTYPage = lazy(() => import('../pages/mint-uty'))
const AdminDashboardPage = lazy(() => import('../pages/admin/dashboard'))
const AdminDepositsPage = lazy(() => import('../pages/admin/deposits'))
const AdminRedemptionsPage = lazy(() => import('../pages/admin/redemptions'))
const AdminWhitelistPage = lazy(() => import('../pages/admin/whitelist'))
const AdminRolesPage = lazy(() => import('../pages/admin/roles'))
const AdminConfigurationPage = lazy(() => import('../pages/admin/configuration'))
const AdminFundsPage = lazy(() => import('../pages/admin/funds'))
const AdminHomePage = lazy(() => import('../pages/admin/home'))

const RouteComponents: Record<RoutePath, ReactNode> = {
    [RoutePaths.Home]: <HomePage />,
    [RoutePaths.Portfolio]: <PortfolioPage />,
    [RoutePaths.GetUTY]: <GetUTYPage />,
    [RoutePaths.UseUTY]: <UseUTYPage />,
    [RoutePaths.Documentation]: <DocumentationPage />,
    [RoutePaths.TermsOfUse]: <TermsOfUsePage />,
    [RoutePaths.PrivacyPolicy]: <PrivacyPolicyPage />,
    [RoutePaths.MintUTY]: <MintUTYPage />,
    [RoutePaths.AdminHome]: <AdminHomePage />,
    [RoutePaths.AdminDashboard]: <AdminDashboardPage />,
    [RoutePaths.AdminDeposits]: <AdminDepositsPage />,
    [RoutePaths.AdminRedemptions]: <AdminRedemptionsPage />,
    [RoutePaths.AdminWhitelist]: <AdminWhitelistPage />,
    [RoutePaths.AdminRoles]: <AdminRolesPage />,
    [RoutePaths.AdminConfiguration]: <AdminConfigurationPage />,
    [RoutePaths.AdminFunds]: <AdminFundsPage />,
}

export const Routes: FC = () => {
    return (
        <RouterRoutes>
            {allRoutes.map((route) => (
                <Route
                    key={route.path}
                    path={route.path}
                    element={RouteComponents[route.path]}
                    data-testid="route"
                    errorElement={<NotFound />}
                />
            ))}
            <Route path="*" element={<NotFound />} />
        </RouterRoutes>
    )
}
